/**
 * @file Renders the table row element used by the editable collection.
 */
import React from "react";
import type { HTMLAttributes } from "react";

type Props = HTMLAttributes<HTMLTableRowElement>;

/**
 * Renders a plain table row, forwarding its props.
 */
const CollectionRow = (props: Props): JSX.Element => (
  <tr {...props} />
);

export default CollectionRow;
